<template>
    <div id="photo-selector-from-webcam"
         class="modl-tab-body">
        <div class="modl-body">
            <div class="photo-selector-modal__layout">
                <div class="photo-selector-modal__img-preview">
                    <img v-if="photoData"
                         :src="photoData" />

                    <div v-if="webcamError"
                         class="alert alert-danger mb-0 mt-1">
                        <p>{{ l('PHOTO_SELECTOR.WEBCAM_ERROR') }}</p>
                        <p>{{ webcamError }}</p>
                    </div>
                    <WebcamFeed v-show="!webcamError && !photoData"
                                ref="webcam-feed"
                                :width="640"
                                :height="480"
                                @click.prevent="takePhotoFromWebcam"
                                @error="setWebcamError" />
                </div>
                <div class="photo-selector-modal__btn-section">
                    <a v-if="photoData"
                       class="btn btn-danger btn-lg btn-block"
                       @click="clear">
                        <i class="fa-solid fa-trash-can"></i>
                        {{ l('PHOTO_SELECTOR.RETAKE_PHOTO') }}
                    </a>
                    <a v-else-if="!webcamError"
                       class="btn btn-lg btn-primary btn-block"
                       @click="takePhotoFromWebcam">
                        <i class="fa-solid fa-camera"></i>
                        {{ l('PHOTO_SELECTOR.TAKE_PHOTO') }}
                    </a>
                </div>
            </div>
        </div>

        <div class="modl-footer">
            <!-- Cancel button -->
            <button class="btn btn-lg btn-default cancel-btn"
                    @click.prevent="$emit('cancel')">
                {{ l('CANCEL') }}
            </button>

            <!-- OK button -->
            <button v-if="photoData"
                    class="btn btn-lg btn-primary"
                    @click.prevent="$emit('resolve', { photoData });">
                {{ l('PHOTO_SELECTOR.USE_PHOTO') }}
            </button>
        </div>
    </div>
</template>

<script>
import WebcamFeed from '@/vue/modals/PhotoSelector/WebcamFeed';

export default {
    components: {
        WebcamFeed,
    },

    emits: [
        'cancel',
        'resolve',
    ],

    data() {
        return {
            photoData: null,
            webcamError: null,
        };
    },

    methods: {
        clear() {
            this.photoData = null;
            this.setWebcamError(null);
        },

        takePhotoFromWebcam() {
            this.photoData = this.$refs['webcam-feed'].getPhoto();
        },

        /**
         * @param {?Error} err
         */
        setWebcamError(err) {
            this.webcamError = err ? err.message : null;
        },
    },
};
</script>
